import { render, staticRenderFns } from "./AnalyticsAvgSessions.vue?vue&type=template&id=b2e31508&"
import script from "./AnalyticsAvgSessions.vue?vue&type=script&lang=js&"
export * from "./AnalyticsAvgSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports